import { useEffect, useState } from "react"

export function useTypingAnimation(
  text: string | undefined,
  inView: boolean,
  speed = 50,
) {
  const [displayed, setDisplayed] = useState("")

  useEffect(() => {
    if (!inView || !text) return
    let i = 0
    setDisplayed("")
    const interval = setInterval(() => {
      i++
      setDisplayed(text.slice(0, i))
      if (i >= text.length) clearInterval(interval)
    }, speed)
    return () => clearInterval(interval)
  }, [inView, text, speed])

  return { displayed, full: text || "" }
}
